var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "max-w-xl m-auto" },
    [
      _c("service-orders-search", {
        attrs: { loading: _vm.loadingListServiceOrders },
        on: {
          searchClick: _vm.handleSearchByOrderId,
          searchStatus: _vm.handleSearchByStatus,
        },
      }),
      _c("service-orders-list", {
        attrs: {
          items: _vm.items,
          loading: _vm.loadingListServiceOrders,
          pagination: _vm.pagination,
        },
        on: { onPrevious: _vm.onPrevious, onNext: _vm.onNext },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }